import user from './api/user'
import orders from './api/orders'
import filters from './api/filters'
import labels from './api/labels'
import items from './api/items'
import supplier from './api/supplier'
import sfp from './api/sfp'

const repositories = {
  user,
  orders,
  filters,
  labels,
  items,
  supplier,
  sfp
}

export const Repository = {
  call: name => repositories[name]
}



// WEBPACK FOOTER //
// ./src/repository/repository.js